import React from "react";
import { connect, shallowEqual, useSelector } from "react-redux";
import * as categoryRedux from "modules/Category/_redux/categoryRedux";
import "./sahibindenFilters.css";

// Sahibinden tarzı yıl aralığı: sade min/max input.
// selectedFilter.minMaxYear = [min, max]; backend plugin'i year (seller) ile
// yearMin/yearMax (buyer) field'ları üzerinde uygular.
function SLMinMaxYear(props) {
  const { selectedFilter } = useSelector(
    (state) => ({ selectedFilter: state.category.selectedFilter }),
    shallowEqual
  );

  const value = selectedFilter?.minMaxYear || ["", ""];
  const [min, max] = value;

  const setRange = (nextMin, nextMax) => {
    const empty =
      (nextMin === "" || nextMin === null || nextMin === undefined) &&
      (nextMax === "" || nextMax === null || nextMax === undefined);
    if (empty) {
      props.removeFilter({ parent: "minMaxYear" });
      return;
    }
    props.addFilterBulk({ parent: "minMaxYear", value: [nextMin, nextMax] });
  };

  return (
    <section id={props.filter.id} className="sf-section">
      <div className="sf-title">{props.filter.title || "Yıl"}</div>
      <div className="sf-minmax">
        <input
          className="sf-input"
          type="number"
          placeholder="min"
          value={min == null ? "" : min}
          onChange={(e) =>
            setRange(e.target.value === "" ? "" : Number(e.target.value), max)
          }
        />
        <span className="sf-dash">–</span>
        <input
          className="sf-input"
          type="number"
          placeholder="max"
          value={max == null ? "" : max}
          onChange={(e) =>
            setRange(min, e.target.value === "" ? "" : Number(e.target.value))
          }
        />
      </div>
    </section>
  );
}

export default connect(null, { ...categoryRedux.actions })(SLMinMaxYear);
